<template>
  <section class="p-internetmonitor">
    <section class="c-visible-pc" v-if="$store.state.isPc">
      <section class="monitor-wrap">
        <section class="c-mt-84 monitor-title">
          <p class="c-fs-32 c-mb c-fw-b c-c-text-color-dark">网络性能监控系统</p>
          <p class="c-fs-16 c-mt-36 c-mb-56 c-lh-38 c-ta-j">MonitorWay 网络性能监控系统是功能强大且经济实惠的网络监控软件，让您可以快速检测、诊断和解决网络性能问题及故障。</p>
          <img src="../../assets/monitor/internet.jpg" class="c-cs-p" preview="monitor-internet"/>
        </section>
        <section>
          <div class="c-d-f c-ai-c c-mt-84">
            <img src="../../assets/index/icon.png">
            <span class="c-ml-12 c-fs-24">MonitorWay 网络性能监控系统概览</span>
          </div>
          <div class="c-bc-white c-fs-14 c-c-text-grey c-lh-36 c-mt-40 c-pt-56 c-pl-92 c-pb-56 c-p-r">
            <ul>
              <li>支持 100+ 常见品牌的网络及安全产品。</li>
              <li>加速故障排除，提高服务水平，并减少停机时间。</li>
              <li>快速发现连接关系，并自动生成网络拓扑。</li>
              <li>监控并显示网络设备的响应时间、可用性和性能。</li>
              <li>内置开箱即用的仪表盘、大屏、告警、知识库、报表、资产管理提高运营效率。</li>
              <li>自动发现网络设备，部署通常在一个小时左右即可完成。</li>
            </ul>
            <img src="../../assets/monitor/internet-pic.png" class="c-pr-40 pic">
          </div>
        </section>
        <section class="c-pb-164 features">
          <div class="c-d-f c-ai-c c-mt-80">
            <img src="../../assets/index/icon.png">
            <span class="c-ml-12 c-fs-24">功能介绍</span>
          </div>
          <div class="c-d-f c-jc-sb c-fw-w c-mt-40 features-wrap">
            <div class="c-d-f c-jc-sb c-ai-fs c-bc-white features-item">
              <img src="../../assets/monitor/ip4.png">
              <div class="c-ml-40">
                <p class="c-mb-12 c-fs-20 c-c-text-blue">故障、性能和可用性监控</p>
                <p class="c-ta-j c-fs-14 c-lh-28 c-c-text-grey">秒级监控，可及时发现网络故障并预警，减少停机时间。</p>
              </div>
            </div>
            <div class="c-d-f c-ai-fs c-bc-white features-item">
              <img src="../../assets/monitor/internet2.png">
              <div class="c-ml-40">
                <p class="c-mb-12 c-fs-20 c-c-text-blue">可自定义的拓扑和相关性感知智能警报</p>
                <p class="c-ta-j c-fs-14 c-lh-28 c-c-text-grey">响应多个检查条件、关联事件、网络拓扑和设备相关性。</p>
              </div>
            </div>
            <div class="c-d-f c-ai-fs c-bc-white features-item">
              <img src="../../assets/monitor/internet3.png">
              <div class="c-ml-40">
                <p class="c-mb-12 c-fs-20 c-c-text-blue">动态连接和无线网络发现和映射</p>
                <p class="c-ta-j c-fs-14 c-lh-28 c-c-text-grey">自动发现和映射设备、性能指标、链路使用率和无线覆盖率。</p>
              </div>
            </div>
            <div class="c-d-f c-ai-fs c-bc-white features-item">
              <img src="../../assets/monitor/internet4.png">
              <div class="c-ml-40">
                <p class="c-mb-12 c-fs-20 c-c-text-blue">全面监控 F5 BIG-IP 产品系列</p>
                <p class="c-ta-j c-fs-14 c-lh-28 c-c-text-grey">为您呈现和深入了解 F5 服务提供环境的健康状况和性能。</p>
              </div>
            </div>
            <div class="c-d-f c-ai-fs c-bc-white features-item">
              <img src="../../assets/monitor/internet5.png">
              <div class="c-ml-40">
                <p class="c-mb-12 c-fs-20 c-c-text-blue">无线网络监控和管理</p>
                <p class="c-ta-j c-fs-14 c-lh-28 c-c-text-grey">检索自主式接入点、无线控制器和客户端的性能指标</p>
              </div>
            </div>
            <div class="c-d-f c-ai-fs c-bc-white features-item">
              <img src="../../assets/monitor/internet6.png">
              <div class="c-ml-40">
                <p class="c-mb-12 c-fs-20 c-c-text-blue">免顾问和免服务的部署</p>
                <p class="c-ta-j c-fs-14 c-lh-28 c-c-text-grey">借助开箱即用的监控、警报和报告，在短短一小时内即可完成安装和部署。</p>
              </div>
            </div>
            <div class="c-d-f c-ai-fs c-bc-white features-item">
              <img src="../../assets/monitor/internet7.png">
              <div class="c-ml-40">
                <p class="c-mb-12 c-fs-20 c-c-text-blue">可自定义的单一管理界面网络监控软件</p>
                <p class="c-ta-j c-fs-14 c-lh-28 c-c-text-grey">可自定义的基于网络的网络性能仪表板、视图和图表。</p>
              </div>
            </div>
            <div class="c-d-f c-ai-fs c-bc-white features-item">
              <img src="../../assets/monitor/internet8.png">
              <div class="c-ml-40">
                <p class="c-mb-12 c-fs-20 c-c-text-blue">网络性能动态统计基准</p>
                <p class="c-ta-j c-fs-14 c-lh-28 c-c-text-grey">通过历史网络性能数据动态计算基准阈值。</p>
              </div>
            </div>
            <div class="c-d-f c-ai-fs c-bc-white features-item">
              <img src="../../assets/monitor/internet9.png">
              <div class="c-ml-40">
                <p class="c-mb-12 c-fs-20 c-c-text-blue">监控硬件健康状况</p>
                <p class="c-ta-j c-fs-14 c-lh-28 c-c-text-grey">监控、提醒和报告设备关键指标，包括温度、风扇速度和电源。</p>
              </div>
            </div>
            <div class="c-d-f c-ai-fs c-bc-white features-item">
              <img src="../../assets/monitor/internet10.png">
              <div class="c-ml-40">
                <p class="c-mb-12 c-fs-20 c-c-text-blue">可自定义的性能和可用性报表</p>
                <p class="c-ta-j c-fs-14 c-lh-28 c-c-text-grey">提供 100 多个开箱即用的模板，您可以从中选择以便计划和生成自定义网络性能报告。</p>
              </div>
            </div>
            <div class="c-d-f c-ai-fs c-bc-white features-item">
              <img src="../../assets/monitor/internet11.png">
              <div class="c-ml-40">
                <p class="c-mb-12 c-fs-20 c-c-text-blue">拖动和发现网络性能图表</p>
                <p class="c-ta-j c-fs-14 c-lh-28 c-c-text-grey">从您的网络设备获得实时网络性能指标以及交互式图表和图形。</p>
              </div>
            </div>
          </div>
        </section>
      </section>
    </section>
    <section class="c-visible-mobile" v-if="!$store.state.isPc">
      <section class="cm-width monitor-wrap-mobile">
        <section class="c-mt-40 monitor-title">
          <p class="c-fs-19 c-fw-b c-c-text-color-dark">网络性能监控系统</p>
          <p class="c-fs-12 c-mt-16 c-mb-24 c-lh-22 c-ta-j">MonitorWay 网络性能监控系统是功能强大且经济实惠的网络监控软件，让您可以快速检测、诊断和解决网络性能问题及故障。</p>
          <img src="../../assets/monitor/internet.jpg" class="c-w-100" preview="monitor-internet1"/>
        </section>
        <section>
          <div class="c-d-f c-ai-c c-mt-40">
            <img class="c-icon-mobile" src="../../assets/index/icon.png">
            <span class="c-ml-8 c-fs-16">MonitorWay 网络性能监控系统概览</span>
          </div>
          <div class="c-bc-white c-fs-13 c-c-text-grey c-lh-28 c-mt-24 c-ptb-20 c-pl-36 c-pr-16 c-boxshadow">
            <ul>
              <li>支持 100+ 常见品牌的网络及安全产品。</li>
              <li>加速故障排除，提高服务水平，并减少停机时间。</li>
              <li>快速发现连接关系，并自动生成网络拓扑。</li>
              <li>监控并显示网络设备的响应时间、可用性和性能。</li>
              <li>内置开箱即用的仪表盘、大屏、告警、知识库、报表、资产管理提高运营效率。</li>
              <li>自动发现网络设备，部署通常在一个小时左右即可完成。</li>
            </ul>
          </div>
        </section>
        <section class="features">
          <div class="c-d-f c-ai-c c-mt-40">
            <img class="c-icon-mobile" src="../../assets/index/icon.png">
            <span class="c-ml-8 c-fs-16">功能介绍</span>
          </div>
          <div class="c-mt-24 features-wrap">
            <swiper class="swiper" :options="swiperOption" ref="mySwiper">
              <swiper-slide>
                <div class="c-mb-8 features-item">
                  <div class="c-bc-white c-d-f c-pe-none">
                    <img src="../../assets/monitor/ip4.png">
                    <div class="c-ml-24">
                      <p class="c-fs-15 c-c-text-blue c-mb-8">故障、性能和可用性监控</p>
                      <p class="c-fs-12 c-lh-20 c-c-text-grey">秒级监控，可及时发现网络故障并预警，减少停机时间。</p>
                    </div>
                  </div>
                </div>
                <div class="c-mb-8 features-item">
                  <div class="c-bc-white c-d-f c-pe-none">
                    <img src="../../assets/monitor/internet7.png">
                    <div class="c-ml-24">
                      <p class="c-fs-15 c-c-text-blue c-mb-8">可自定义的单一管理界面网络监控软件</p>
                      <p class="c-fs-12 c-lh-20 c-c-text-grey">可自定义的基于网络的网络性能仪表板、视图和图表。</p>
                    </div>
                  </div>
                </div>
                <div class="c-mb-8 features-item">
                  <div class="c-bc-white c-d-f c-pe-none">
                    <img src="../../assets/monitor/internet2.png">
                    <div class="c-ml-24">
                      <p class="c-fs-15 c-c-text-blue c-mb-8">可自定义的拓扑和相关性感知智能警报</p>
                      <p class="c-fs-12 c-lh-20 c-c-text-grey">响应多个检查条件、关联事件、网络拓扑和设备相关性。</p>
                    </div>
                  </div>
                </div>
                <div class="c-mb-32 features-item">
                  <div class="c-bc-white c-d-f c-pe-none">
                    <img src="../../assets/monitor/internet11.png">
                    <div class="c-ml-24">
                      <p class="c-fs-15 c-c-text-blue c-mb-8">拖动和发现网络性能图表</p>
                      <p class="c-fs-12 c-lh-20 c-c-text-grey">从您的网络设备获得实时网络性能指标以及交互式图表和图形。</p>
                    </div>
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="c-mb-8 features-item">
                  <div class="c-bc-white c-d-f c-pe-none">
                    <img src="../../assets/monitor/internet4.png">
                    <div class="c-ml-24">
                      <p class="c-fs-15 c-c-text-blue c-mb-8">全面监控 F5 BIG-IP 产品系列</p>
                      <p class="c-fs-12 c-lh-20 c-c-text-grey">为您呈现和深入了解 F5 服务提供环境的健康状况和性能。</p>
                    </div>
                  </div>
                </div>
                <div class="c-mb-8 features-item">
                  <div class="c-bc-white c-d-f c-pe-none">
                    <img src="../../assets/monitor/internet5.png">
                    <div class="c-ml-24">
                      <p class="c-fs-15 c-c-text-blue c-mb-8">无线网络监控和管理</p>
                      <p class="c-fs-12 c-lh-20 c-c-text-grey">检索自主式接入点、无线控制器和客户端的性能指标</p>
                    </div>
                  </div>
                </div>
                <div class="c-mb-8 features-item">
                  <div class="c-bc-white c-d-f c-pe-none">
                    <img src="../../assets/monitor/internet3.png">
                    <div class="c-ml-24">
                      <p class="c-fs-15 c-c-text-blue c-mb-8">动态连接和无线网络发现和映射</p>
                      <p class="c-fs-12 c-lh-20 c-c-text-grey">自动发现和映射设备、性能指标、链路使用率和无线覆盖率。</p>
                    </div>
                  </div>
                </div>
                <div class="c-mb-32 features-item">
                  <div class="c-bc-white c-d-f c-pe-none">
                    <img src="../../assets/monitor/internet8.png">
                    <div class="c-ml-24">
                      <p class="c-fs-15 c-c-text-blue c-mb-8">网络性能动态统计基准</p>
                      <p class="c-fs-12 c-lh-20 c-c-text-grey">通过历史网络性能数据动态计算基准阈值。</p>
                    </div>
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="c-mb-8 features-item">
                  <div class="c-bc-white c-d-f c-pe-none">
                    <img src="../../assets/monitor/internet9.png">
                    <div class="c-ml-24">
                      <p class="c-fs-15 c-c-text-blue c-mb-8">监控硬件健康状况</p>
                      <p class="c-fs-12 c-lh-20 c-c-text-grey">监控、提醒和报告设备关键指标，包括温度、风扇速度和电源。</p>
                    </div>
                  </div>
                </div>
                <div class="c-mb-8 features-item">
                  <div class="c-bc-white c-d-f c-pe-none">
                    <img src="../../assets/monitor/internet10.png">
                    <div class="c-ml-24">
                      <p class="c-fs-15 c-c-text-blue c-mb-8">可自定义的性能和可用性报表</p>
                      <p class="c-fs-12 c-lh-20 c-c-text-grey">提供 100 多个开箱即用的模板，您可以从中选择以便计划和生成自定义网络性能报告。</p>
                    </div>
                  </div>
                </div>
                <div class="c-mb-32 features-item">
                  <div class="c-bc-white c-d-f c-pe-none">
                    <img src="../../assets/monitor/internet6.png">
                    <div class="c-ml-24">
                      <p class="c-fs-15 c-c-text-blue c-mb-8">免顾问和免服务的部署</p>
                      <p class="c-fs-12 c-lh-20 c-c-text-grey">借助开箱即用的监控、警报和报告，在短短一小时内即可完成安装和部署。</p>
                    </div>
                  </div>
                </div>
              </swiper-slide>
              <div class="swiper-pagination" id="swiper-pagination1" slot="pagination"></div>
            </swiper>
          </div>
        </section>
      </section>
    </section>
  </section>
</template>

<script>
export default {
  name: 'internet',
  data () {
    return {
      swiperOption: {
        ...this.$store.state.swiperOptions,
        pagination: {
          el: '#swiper-pagination1',
          clickable: true
        }
      }
    }
  }
}
</script>

<style lang="scss">
.p-internetmonitor {
  // min-height: calc(100vh - 44px - 161px);
  @media screen and (min-width: 1180px) {
    min-height: calc(100vh - 90px - 525px);
    background: url('../../assets/monitor/monitor-bg.png') no-repeat;
    background-position: bottom;
    background-size: 100%;
  }
  .monitor-wrap {
    width: 1180px;
    margin: 0 auto;
    .monitor-title {
      img {
        height: 417px;
      }
    }
    .pic {
      position: absolute;
      right: 0;
      top: -70px;
    }
    .features {
      .features-wrap {
        .features-item {
          width: calc(50% - 7px);
          padding: 44px 54px;
          margin-bottom: 14px;
          box-shadow: 0 8px 34px 0 rgba(0, 31, 255, 0.05);
          border-radius: 1px;
          img {
            width: 18%;
          }
        }
      }
    }
  }
  .monitor-wrap-mobile {
    .monitor-title {
      img {
        width: 100%;
      }
    }
    .features {
      .features-wrap {
        padding-bottom: 25px;
        .features-item {
          width: 100%;
          // min-height: 120px;
          // display: flex;
          // align-items: center;
          // padding: 0 16px;
          padding: 25px 16px;
          background: white;
          text-align: justify;
          img {
            width: 38px;
            height: 38px;
            object-fit: contain;
          }
        }
      }
    }
    .swiper {
      width: 100%;
      --swiper-theme-color: #FF8243; // 不能使用$orange
      .swiper-pagination, .swiper-pagination-bullets {
        bottom: 15px;
        .swiper-pagination-bullet {
          width: 20px;
          height: 3px;
          border-radius: 1.5px;
          margin: 0 4px;
          outline: none;
        }
        .swiper-pagination-bullet-active {
          width: 50px;
        }
      }
    }
  }
}
</style>
